import {Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';

import { WellSegmentModel, CasingType } from "../../../new-casing-plan/models/casing-plan.model";
import { CasingPlan2dSchematicComponent } from './casing-plan-2d-schematic.component';

@Component({
    selector: 'casing-plan-2d-schematic-vertical',
    templateUrl: './casing-plan-2d-schematic-base.component.html',
    styleUrls: ['./casing-plan-2d-schematic.component.scss'],
    standalone: false
})
export class CasingPlan2dSchematicVerticalComponent extends CasingPlan2dSchematicComponent implements OnInit {
    @Input() applicationData: any = {};
    bottomMargin: number = 75;
    canvasRightPadding: number = 20;
    direction: string = "Vertical";

   // _infoBoxHeight: number = 105;                 
    _infoBoxWidth:number = 225;                 
    _leftRightInfoBoxCanvasPadding: number = 15; //space between canvas edge and the outside of the info box
    _circleRadius: number = 14;
    _infoBoxPadding: number = 8;
    _numberFont: string = "bold 20px 'Work Sans'";
    _sizeFont: string = "bold 14px 'Work Sans'";
    _font: string = "12px 'Work Sans'";



    constructor(el: ElementRef) {
        super();
    }

    ngOnInit(): void {        
        //Uncomment for production
        if (this.casingPlan != null) {
            let hasPosition = this.casingPlan.wellSegments.filter(w => w.position != null && w.position > 0).sort((a, b) => {
                if (a.position < b.position) return -1;
                if (a.position > b.position) return 1;
                return 0;
            });
            let hasDimensions = this.casingPlan.wellSegments.filter(w => this.hasBorehole(w) || this.hasCasing(w)).sort((a, b) => {
                let topA = this.hasBorehole(a) ? a.boreholeDiameter : a.casingDiameter;
                let topB = this.hasBorehole(b) ? b.boreholeDiameter : b.casingDiameter;
                if (topA < topB) return -1;
                if (topA > topB) return 1;
                return 0;
            });;
            this.wellSegments = hasPosition.length > 0 ? hasPosition : hasDimensions;
        }
        this.setVars("Vertical");

        this.canvasHeight = 690; //TODO: need to fix this, temp adds spacing at bottom of vertical schematic

        if (this.haveSegmentData()) {
            //populate reusable variables
            

            //add canvas shapes & text
            this.updateCanvas();

            //draw application number in lower right
            this.drawApplicationNumber();
        } else {
            console.log("No segments provided for the schematic rendering!");
            this.showError("No segments suitable for rendering schematic available");
        }


    }

    /**
     * Main function to create diagram
     */
    updateCanvas(): void {
        let stringLengthPercent = (this.canvasHeight - this.bottomMargin) / this.totalStringLength;

        this.addWhiteBackground(750, 750);
        let length: number;
        const totalWidth: number = this.wellSegments.length * 40;

        let sortByLength = this.wellSegments.sort((a, b) => {
            const alength = (a.casingLength != null) ? a.casingLength : a.boreholeDepth;
            const blength = (b.casingLength != null) ? b.casingLength : b.boreholeDepth;
            if (alength > blength) return 1;
            if (alength < blength) return -1;
            return 0;
        });
        const lengthArray: number[] = [];
        const longest = (sortByLength[sortByLength.length -1].casingLength != null) ? sortByLength[sortByLength.length -1].casingLength : sortByLength[sortByLength.length -1].boreholeDepth;
        this.wellSegments = this.wellSegments.sort((a, b) => {
            if (a.position > b.position) return 1;
            if (a.position < b.position) return -1;
            return 0;
        }); //ensure placement in design order, rather than length order

        const rightArray: number[] = [];
        const leftArray: number[] = [];
        
        this.wellSegments.forEach((segment, index) => {
            let boxHeight = this.getInfoBoxHeight(segment);
            const verticalOffset: number = boxHeight * 2; 
            this.segmentIndex = index;
            let currentWidth: number = totalWidth - (index * 40);
            length = (this.hasCasing(segment))
                ? segment.casingLength / longest
                : segment.boreholeDepth / longest;
            
            const leftSide = this.canvasCenter - currentWidth / 2;
            const rightSide = this.canvasCenter + currentWidth / 2;
            const lineStart = (this.hasCasing(segment))
                ? segment.casingTop
                : segment.boreholeTop;

            const proportion = length * this.canvasHeight * .8; //set the 'length' to the relative proportional length times 80% of the canvas height
            let position = proportion;
            if (this.isEven(index)) { //left
                const exists = leftArray.findIndex(l => l === proportion);
                position = (exists === -1) ? proportion : proportion + verticalOffset;
                if (position < 15) position = 15;
                if (leftArray.length > 0) {
                    const previous = leftArray[leftArray.length - 1];
                    const diff = position - previous;
                    if (diff < boxHeight) {
                        position = previous + boxHeight + 10;
                    }
                }
                leftArray.push(position);
                lengthArray.push(position);
            } else { //right
                const exists = rightArray.findIndex(r => r === proportion);
                position = (exists === -1) ? proportion : proportion + verticalOffset;
                if (position < 15) position = 15;
                if (rightArray.length > 0) {
                    const previous = rightArray[rightArray.length - 1];
                    const diff = position - previous;
                    if (diff < boxHeight) {
                        position = previous + boxHeight + 10;
                    }
                }
                rightArray.push(position);
                lengthArray.push(position);
            }
            this.addSegmentLines(rightSide, leftSide, lineStart, proportion, true);
            this.drawInfoBoxLine(rightSide, leftSide, index, proportion, position);
            this.addGround();            
        });
        this.drawInfoBoxes(lengthArray);
    }

    getInfoBoxHeight(segment: WellSegmentModel): number {
        if (segment == null) return super.getInfoBoxHeight(null);
        let dataPoints = 0;
        if (segment.casingType != null) dataPoints += 1;
        if (segment.boreholeDepth != null) dataPoints += 1;
        if (segment.boreholeDiameter != null) dataPoints += 1;
        if (segment.casingDiameter != null) dataPoints += 1;
        if (segment.casingLength != null) dataPoints += 1;
        if (segment.cementTop != null) dataPoints += 1;
        if (segment.cementVolume != null) dataPoints += 1;
        if (dataPoints > 0 && dataPoints < 7) dataPoints += 1; //reserve enough space for the casing type if box is otherwise smaller than maximum
        return (dataPoints > 0) ? dataPoints * 15 : 105;
    }

    /**
     * Draws lines from info boxes to string
     */
    drawInfoBoxLine(segmentRightPosition: number, segmentLeftPosition: number, index: number, length: number, stringBottom: number): void {
        const segment = (index < this.wellSegments.length && index >= 0) ? this.wellSegments[index] : null;
        let rightBoxLeftX = this.getInfoBoxLeft(true);
        let leftBoxRightX = this.getInfoBoxLeft(false) + this._infoBoxWidth;
        this.ctx.beginPath();
        this.ctx.strokeStyle = "#000000";
        this.ctx.lineWidth = 1;

        //offset to center line horizontally on string
        segmentRightPosition -= this.infoBoxSegmentOffset;
        segmentLeftPosition += this.infoBoxSegmentOffset;
        let stringBottomWithOffset = stringBottom + (this.getInfoBoxHeight(segment) / 2);

        if (this.isEven(index)) {
            //Right
            this.ctx.moveTo(rightBoxLeftX, stringBottomWithOffset);
            this.ctx.lineTo(segmentRightPosition, stringBottomWithOffset);
            const bottom = (stringBottom !== length) ? length : stringBottom;
            this.ctx.lineTo(segmentRightPosition, bottom + 2);
            this.ctx.stroke();

        } else {
            //Left
            this.ctx.moveTo(leftBoxRightX, stringBottomWithOffset);
            this.ctx.lineTo(segmentLeftPosition, stringBottomWithOffset);
            const bottom = (stringBottom !== length) ? length : stringBottom;
            this.ctx.lineTo(segmentLeftPosition, bottom + 2);
            this.ctx.stroke();
        }

        this.ctx.closePath();
    }

    /**
     * Main method for creating info box in canvas
     * */
    drawInfoBoxes(lengthArray: number[] = []): void {
        if (lengthArray.length === 0) {
            const rightArray: number[] = [];
            const leftArray: number[] = [];
            for (let i = 0; i < this.wellSegments.length; i++) {
                const segment = this.wellSegments[i];
                let boxHeight = this.getInfoBoxHeight(segment);
                const verticalOffset: number = boxHeight * 2; 
                
                const position = this.hasCasing(segment) ? segment.casingLength : segment.boreholeLength;
                let assumed = position;
                if (this.isEven(i)) { //left
                    const exists = leftArray.findIndex(l => l === position);
                    assumed = (exists === -1) ? position : position + verticalOffset;
                    if (leftArray.length > 0) {
                        const previous = leftArray[leftArray.length - 1];
                        const diff = position - previous;
                        if (diff < (boxHeight / 2)) {
                            assumed = position + (boxHeight / 2);
                        }
                    }
                    leftArray.push(assumed);
                    lengthArray.push(assumed);
                } else { //right
                    const exists = rightArray.findIndex(l => l === position);
                    assumed = (exists === -1) ? position : position + verticalOffset;
                    if (rightArray.length > 0) {
                        const previous = rightArray[rightArray.length - 1];
                        const diff = position - previous;
                        if (diff < (boxHeight / 2)) {
                            assumed = assumed + (boxHeight / 2);
                        }
                    }
                    rightArray.push(assumed);
                    lengthArray.push(assumed);
                }
            }
            //lengthArray = this.wellSegments.map(m => (this.hasCasing(m) ? m.casingLength : m.boreholeLength));
        }
        this.wellSegments.forEach((segment, index) => {
            //get vertical location for each string
            let lineStart = lengthArray[index];

            const increment = 12;
            if (this.isEven(index)) {

                this.drawInfoBoxVerticalSchematicOnly(true, lineStart, segment);
              //  this.drawInfoBoxDiameter(true, lineStart, diameter, labelText);
                let position = lineStart;     
                if (segment.boreholeDiameter != null) {
                    this.drawInfoBoxDiameter(true, position, segment.boreholeDiameter, "HOLE");
                    position = position + increment;
                }
                if (segment.boreholeDepth != null) {
                    this.drawInfoBoxDepth(true, position, segment.boreholeDepth, "HOLE");
                    position = position + increment;
                }
                if (segment.casingDiameter != null) {
                    this.drawInfoBoxDiameter(true, position, segment.casingDiameter, "CASING");
                    position = position + increment;
                }
                if (segment.casingLength != null) {
                    this.drawInfoBoxDepth(true, position, segment.casingLength, "CASING");
                    position = position + increment;
                }
                if (segment.cementTop != null) {
                    const label = `${segment.cementTop} FT. CEMENT TOP`;
                    this.drawInfoBoxCement(true, position, label);
                    position = position + increment;
                }
                if (segment.cementVolume != null) {
                    const label = `${segment.cementVolume} SACKS CEMENT`;
                    this.drawInfoBoxCement(true, position, label);
                }
                this.drawInfoBoxCasingType(true, lineStart, segment);
                //need to add cement fields
                this.drawInfoBoxSegmentNumber(true, lineStart, index + 1);

            } else {

                this.drawInfoBoxVerticalSchematicOnly(false, lineStart, segment);
                let position = lineStart;
                if (segment.boreholeDiameter != null) {
                    this.drawInfoBoxDiameter(false, position, segment.boreholeDiameter, "HOLE");
                    position = position + increment;
                }
                if (segment.boreholeDepth != null) {
                    this.drawInfoBoxDepth(false, position, segment.boreholeDepth, "HOLE");
                    position = position + increment;
                }
                if (segment.casingDiameter != null) {
                    this.drawInfoBoxDiameter(false, position, segment.casingDiameter, "CASING");
                    position = position + increment;
                }
                if (segment.casingLength != null) {
                    this.drawInfoBoxDepth(false, position, segment.casingLength, "CASING");
                    position = position + increment;
                }
                if (segment.cementTop != null) {
                    const label = `${segment.cementTop} FT CEMENT TOP`;
                    this.drawInfoBoxCement(false, position, label);
                    position = position + increment;
                }
                if (segment.cementVolume != null) {
                    const label = `${segment.cementVolume} SACKS CEMENT`;
                    this.drawInfoBoxCement(false, position, label);
                }
                this.drawInfoBoxCasingType(false, lineStart, segment);
                this.drawInfoBoxSegmentNumber(false, lineStart, index + 1);
            }
            
        });
    }

    /**
     * Get's left X value for an info box
     * @param right
     */
    getInfoBoxLeft(right: boolean): number {
        return right ? this.canvasWidth - this._leftRightInfoBoxCanvasPadding - this._infoBoxWidth : this._leftRightInfoBoxCanvasPadding;;
    }

    /**
     * Draws circle and number
     * @param right
     * @param startY
     * @param wellStringNumber
     */
    drawInfoBoxSegmentNumber(right: boolean, startY: number, wellStringNumber:number): void {
       // let infoBoxCenterY = startY + (this._infoBoxHeight / 2);
        let infoBoxCenterY = startY + (this.getInfoBoxHeight(this.wellSegments[wellStringNumber - 1]) / 2);
        let infoBoxLeftX = this.getInfoBoxLeft(right);
        let circleLeftX = infoBoxLeftX + this._circleRadius + this._infoBoxPadding;

        //draw circle
        this.ctx.beginPath();
        this.ctx.arc(circleLeftX, infoBoxCenterY, this._circleRadius, 0, 2 * Math.PI);
        this.ctx.stroke();
        this.ctx.closePath();

        //draw number
        this.ctx.beginPath();
        this.ctx.font = this._numberFont;
        this.ctx.textAlign = "center";
        //'(this._circleRadius / 2)' centers number vertically in circle
        this.ctx.fillText(wellStringNumber.toString(), circleLeftX, infoBoxCenterY + (this._circleRadius / 2));
        this.ctx.closePath();

        //reset text align
        this.ctx.textAlign = "left";
    }

    drawInfoBoxDepth(right: boolean, startY: number, depth: number, labelText: string): void {
        let infoBoxX = this.getInfoBoxLeft(right);
        let textX = infoBoxX + (2 * this._infoBoxPadding) + (2 * this._circleRadius);
        let textY = startY + 20;
        this.ctx.font = this._sizeFont;
        this.ctx.fillText(`${depth} FT. DEPTH ${labelText}`, textX, textY);
    }

    /**
     * Draws casing diameter
     * @param right
     * @param startY
     * @param diameter
     */
    drawInfoBoxDiameter(right: boolean, startY: number, diameter: number, labelText: string): void {
        let infoBoxX = this.getInfoBoxLeft(right);
        let textX = infoBoxX + (2 * this._infoBoxPadding) + (2 * this._circleRadius);
        let textY = startY + 20;
        //draw text
        this.ctx.font = this._sizeFont;
        ///top line
        this.ctx.fillText(diameter + ` IN. ${labelText}`, textX, textY);
    }

    /**
     * Draws casing type
     * @param right
     * @param startY
     * @param casingType
     */
    drawInfoBoxCasingType(right: boolean, startY: number, segment: WellSegmentModel): void {
        let infoBoxX = this.getInfoBoxLeft(right);
        let textX = infoBoxX + (2 * this._infoBoxPadding) + (2 * this._circleRadius);
       // let textY = startY + this._infoBoxHeight - 10;
        let textY = startY + this.getInfoBoxHeight(segment) - 10;
        let casingType = segment.casingType.definition;
        //draw text
        this.ctx.font = this._font;
        ///bottom line
        this.ctx.fillText("Type: " + casingType.replace(" Casing", ""), textX, textY);
    }

    drawInfoBoxCement(right: boolean, startY: number, label: string): void {
        let infoBoxX = this.getInfoBoxLeft(right);
        let textX = infoBoxX + (2 * this._infoBoxPadding) + (2 * this._circleRadius);
        let textY = startY + 20;
        this.ctx.font = this._sizeFont;
        this.ctx.fillText(label, textX, textY);
    }

    /**
     * Surrounding info box only
     * @param right - is right or left info box
     * @param startY - upper y location of the box corner
     */
    drawInfoBoxVerticalSchematicOnly(right: boolean, startY: number, segment: WellSegmentModel): void {
        let bottomY = startY + this.getInfoBoxHeight(segment); // this._infoBoxHeight;
        this.ctx.beginPath();
        this.ctx.lineWidth = 1;
        this.ctx.strokeStyle = "#000000";

        if (right) {

            let rightX = this.canvasWidth - this._leftRightInfoBoxCanvasPadding;
            let leftX = this.canvasWidth - this._leftRightInfoBoxCanvasPadding - this._infoBoxWidth;
            //upper right
            this.ctx.moveTo(rightX, startY);
            //lower right
            this.ctx.lineTo(rightX, bottomY);
            //lower left
            this.ctx.lineTo(leftX, bottomY);
            //upper left
            this.ctx.lineTo(leftX, startY);

        } else {

            let leftX = this._leftRightInfoBoxCanvasPadding;
            let rightX = this._infoBoxWidth + this._leftRightInfoBoxCanvasPadding;
            //upper left
            this.ctx.moveTo(leftX, startY);
            //upper right
            this.ctx.lineTo(rightX, startY);
            //lower right
            this.ctx.lineTo(rightX, bottomY);
            //lower left
            this.ctx.lineTo(leftX, bottomY);

        }

        this.ctx.closePath();
        this.ctx.stroke();
    }

    /**
     * Draws center rectangle for the final string
     */
    drawCenterSegment(segment: WellSegmentModel): void {
        let diagramFullStringHeight = this.canvasHeight - (.5 * this.bottomMargin);

        this.ctx.beginPath();
        //SHAPES
        //Draw center casing
        this.ctx.rect((this.canvasWidth / 2), 0, this.segmentWidth, diagramFullStringHeight);
        this.ctx.strokeStyle = '#000000';
        this.ctx.stroke();

        //add center shoe?
        if (this.hasValidValue(segment.casingShoeDepth, 'number')) {
            //"- 1" makes show align with rectangle bottom better
            this.addShoeToCanvas(
                this.ctx,
                diagramFullStringHeight - (this.shoeHW - 1),
                this.canvasCenter + this.segmentWidth,
                this.canvasCenter - this.segmentWidth,
                true);
        }

        //LABELS
        //get end of previous string
        let lineStart = this.getCumlativeLength(this.segmentIndex);
        
        //add position for last info box
        let length = this.checkLength(diagramFullStringHeight - lineStart);

        //draw info box line for production casing
        this.drawInfoBoxLine(this.canvasCenter, this.canvasCenter, this.segmentIndex, 800, this.canvasHeight - (.5 * this.bottomMargin));

        this.ctx.closePath();
    }

    drawApplicationNumber(): void {
        this.ctx.font = this._font;
        if (!this.isEven(this.wellSegments.length)) {
            this.ctx.textAlign = "left";
            
            this.ctx.fillText("Application Number: " + this.applicationData.applicationNumber, this.canvasRightPadding, this.canvasHeight);
        } else {
            this.ctx.textAlign = "right";
            this.ctx.fillText("Application Number: " + this.applicationData.applicationNumber, this.canvasWidth - this.canvasRightPadding, this.canvasHeight);
        }


    }
}
